import React, { memo } from "react";
import { BarChart as BarRechart, Bar, XAxis, YAxis, Cell } from "recharts";

import * as SC from "./BarChart.styled";

import DataVizStore from "../../../../../Stores/DataVizStore";
import { withRefluxStore } from "../../../../../Stores";

const skeletonData = [
  { name: "skeleton", value: 1 },
  { name: "skeleton 2", value: 2 }
];

const BarChart = memo(({ data, selectedChannel, isAnimationActive = true, cardKey = "" }) => {
  const isChannelValueEmpty = data.every((metric) => metric.value == 0 || metric.value == null);

  const isSelectedChannelValueEmpty = data.some(
    (metric) =>
      metric.name == selectedChannel[cardKey] && (metric.value == 0 || metric.value == null)
  );

  // Filter out metrics with value 0
  const filteredData = data.filter((metric) => metric.value > 0);

  return (
    <BarRechart
      width={60}
      height={60}
      data={isChannelValueEmpty || isSelectedChannelValueEmpty ? skeletonData : filteredData}
      layout="vertical"
      barCategoryGap={3}
    >
      <XAxis type="number" hide={true} />
      <YAxis type="category" dataKey="value" hide={true} />
      <Bar
        layout="vertical"
        fill="#8884d8"
        key={Math.random()}
        dataKey="value"
        radius={3}
        minPointSize={2}
        isAnimationActive={isAnimationActive}
      >
        {isChannelValueEmpty || isSelectedChannelValueEmpty ? (
          <Cell key={`cell-empty`} fill={"#ABB4F4"} />
        ) : (
          filteredData.map((metric, index) => (
            <Cell
              key={`cell-${index}`}
              fill={SC.selectColorPalette(index, metric, selectedChannel[cardKey])}
              className="animated-cell"
            />
          ))
        )}
      </Bar>
    </BarRechart>
  );
});

BarChart.displayName = "BarChart";
export default withRefluxStore(BarChart, [DataVizStore], ["selectedChannel"]);
